import { CompareProduct, ProductVariant } from '@/compare/types';

export function extractProductData(input: HTMLInputElement): CompareProduct {
  const productId = input.value;
  const rawFeatures = input.getAttribute('data-product-features') || '';
  const rawCompareFeatures = input.getAttribute('data-product-compare-features') || '{}';
  const rawVariants = input.getAttribute('data-product-variants') || '[]';
  const techDataEl = document.getElementById(`tech-data-${productId}`);

  return {
    id: productId,
    title: input.getAttribute('data-product-title') || '',
    image: input.getAttribute('data-product-image') || '',
    price: input.getAttribute('data-product-price') || '',
    comparePrice: input.getAttribute('data-product-compare-price') || '',
    newApproximatePrice: input.getAttribute('data-product-new-approximate-price') || '',
    url: input.getAttribute('data-product-url') || '#',
    currentVariantId: input.getAttribute('data-current-variant-id') || '',
    optionNames: input.getAttribute('data-product-option-names') || '',
    features: rawFeatures ? rawFeatures.split('|||') : [],
    tags: (input.getAttribute('data-product-tags') || '').split(',').filter(Boolean),
    compareFeatures: parseSafeJSON(rawCompareFeatures, {}),
    variants: parseVariants(rawVariants),
    techData: parseSafeJSON(techDataEl?.textContent || '[]', []),
  };
}

function parseSafeJSON<T>(json: string | null | undefined, fallback: T): T {
  if (!json) return fallback;
  try {
    return JSON.parse(json) as T;
  } catch {
    return fallback;
  }
}

function parseVariants(raw: string): ProductVariant[] {
  try {
    const parsed = JSON.parse(raw);
    return parsed.map((v) => ({
      id: v.id.toString(),
      title: v.title,
      price: v.price,
      available: v.available,
      compare_at_price: v.compare_at_price || null,
      options: Array.isArray(v.options) ? v.options.join(' / ') : v.options || '',
    }));
  } catch {
    return [];
  }
}
